import { TextSizeButton } from "components/TextSizeComponent/TextSizeButton";

interface BreadcrumbsProps {
  page: "Start" | "RecentFiles";
}

const Breadcrumbs = ({ page }: BreadcrumbsProps) => {
  return (
    <>
      {page === "Start" ?
        <div className="flex">
          <nav aria-label="Breadcrumb">
            <ol id="startpageBreadCrumb" className="inline-flex items-center space-x-1 md:space-x-2">
              <li className="inline-flex items-center">
                <a
                  href="/"
                  className="!text-[rgb(44,43,43)] !no-underline hover:text-gray-900 inline-flex items-center"
                >
                  <svg
                    className="w-5 h-5 mr-2.5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                  </svg>
                  Logistikportalen
                </a>
              </li>

              <li className="inline-flex items-center">
                <a
                  href="#"
                  className="!text-[rgb(44,43,43)] !no-underline hover:text-gray-900 inline-flex items-center"
                >
                  <svg
                    className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 6 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 9 4-4-4-4"
                    />
                  </svg>
                  Start
                </a>
              </li>
            </ol>
          </nav>
          <div className="ml-auto flex pr-[30px]!">
            <TextSizeButton tooltipPlacement="left"/>
          </div>
        </div>
        :
        <div className="flex ml-[-35px]">
          <nav aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-2">
              <li className="inline-flex items-center">
                <a
                  href="/"
                  className="!text-[rgb(44,43,43)] !no-underline hover:text-gray-900 inline-flex items-center text-base"
                >
                  <svg
                    className="w-5 h-5 mr-2.5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                  </svg>
                  Logistikportalen
                </a>
              </li>

              <li className="inline-flex items-center">
                <a
                  
                  className="!text-[rgb(44,43,43)] !no-underline hover:text-gray-900 inline-flex items-center text-base"
                >
                  <svg
                    className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 6 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 9 4-4-4-4"
                    />
                  </svg>
                  Senast uppdaterade filer
                </a>
              </li>
            </ol>
          </nav>
          <div className="ml-auto flex pr-[30px]!">
            <TextSizeButton 
              tooltipPlacement="left"
            />
          </div>
        </div>
      }
    </>
  );
};
export default Breadcrumbs;
